<div class="user-input-holder">
    <input
        placeholder="Select customer"
        class="user-selctor-trigger"
        readonly
        mat-button
        [matMenuTriggerFor]="menu"
        [value]="selectedCustomerName"
        #dropdownTrigger="matMenuTrigger" />
    <div
        *ngIf="selectedCustomerId"
        class="cancel-user-btn"
        (click)="unselectUser()">
        &#10005;
    </div>
</div>

<mat-menu
    #menu="matMenu"
    class="user-selector-dropdown-holder">
    <app-user-selector
        [settingsData]="userSelectorSettings"
        (usersSelected)="selectUser($event)"
        (click)="$event.stopPropagation()"
        (addNewLead)="showCreateCustomerDlg()"
        (keydown)="$event.stopPropagation()"></app-user-selector>
</mat-menu>
